import * as z from 'zod';

const SocialMediaZod = z.object({
  id: z.number(),
  type: z.enum(['facebook', 'x', 'instagram', 'linkedin', 'youtube']),
  link: z.string(),
});

export { SocialMediaZod };
export type SocialMediaType = z.infer<typeof SocialMediaZod>;
